import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq-heading" className="w-full bg-white" data-id="element-98" data-mp="1l9o8dd7a47nu">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-id="element-99" data-mp="1ge8vanh3ifsh">
        <h2 id="faq-heading" className="font-serif font-bold text-ink text-2xl sm:text-4xl text-center" data-id="element-100" data-mp="2e0ppvkyg2faj">
          Questions, answered
        </h2>

        <ul className="mt-10 border-t border-cream-dark" data-id="element-101" data-mp="24205nlj2sir4">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.question} className="border-b border-cream-dark" data-id="element-102" data-mp="1z59sb5yno19e" data-mpi={index}>
                <h3 data-id="element-103" data-mp="sooadz1dt8gk">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="w-full flex items-start justify-between gap-4 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-sage/40 rounded-lg" data-id="element-104" data-mp="sl0h90zumo2d">
                    <span className="font-semibold text-ink text-[15px] sm:text-base" data-id="element-105" data-mp="fiypxtoivs37">
                      {faq.question}
                    </span>
                    {isOpen ? <MinusIcon className="w-5 h-5 mt-0.5 text-sage shrink-0" aria-hidden="true" data-id="element-106" data-mp="6r6no69njp9p" /> : <PlusIcon className="w-5 h-5 mt-0.5 text-ink-muted shrink-0" aria-hidden="true" data-id="element-107" data-mp="3szfxuvazvmf0" />}
                  </button>
                </h3>

                <AnimatePresence initial={false} data-id="element-108" data-mp="3jyrr8lnxkoc5">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-109" data-mp="3nz1zk4z73qu6">
                      <p className="pb-6 pr-8 text-[15px] leading-relaxed text-ink-soft" data-id="element-110" data-mp="1fq3v8perxenz">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}